export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const phone = '+48 5710 81639';
export const email = 'd.astapchenia@andersenlab.com';
